<!-- ListCell.vue -->
<script setup lang="ts">
  import { ICellProps } from '@/types'
  import { Typography } from '@components/index'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<ICellProps>()
  const defaultIcon = props.icon ?? 'arrow-right-square-fill'
  const onClick = props.onClick ?? (() => {})

  const handleClick = () => {
    onClick()
  }
</script>

<template>
  <div
    :id="props.id"
    class="cell-wrapper d-flex align-items-center px-4 rounded-3"
    @click="handleClick"
  >
    <Typography
      variant="bullet-info-title"
      class="cell-title flex-grow-1"
    >
      {{ props.title }}
    </Typography>
    <i
      class="cell-icon ms-3"
      :class="loadIcon(defaultIcon)"
    />
  </div>
</template>

<style scoped lang="scss">
  .cell-wrapper {
    cursor: pointer;
    background-color: #2d3034;
    min-height: 76px;
  }

  .cell-title {
    padding-inline: 0px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
  }
</style>
